import { Box, Flex } from '@chakra-ui/react'

const BigSwitch = ({
  value,
  leftLabel,
  rightLabel,
  setValue,
  width,
  maxWidth,
}: {
  value: boolean
  leftLabel: string
  rightLabel: string
  setValue: (value: boolean) => void
  width?: string
  maxWidth?: string
}) => {
  return (
    <Flex
      bg="sandstone"
      borderRadius="full"
      onClick={() => setValue(!value)}
      cursor="pointer"
      w={width || '100%'}
      maxW={maxWidth || 'auto'}
      py={{ base: 3, md: '12px' }}
      className="body-small-emphasis"
      position="relative"
    >
      <Box
        w="calc(50% - 12px)"
        bg="white"
        top="6px"
        ml="6px"
        left={value ? '0' : '50%'}
        transition="left 0.3s ease-out"
        bottom="6px"
        borderRadius="full"
        position="absolute"
      />
      <Box
        flexGrow={1}
        textAlign="center"
        color={value ? 'onyx' : 'stone'}
        transition="color 0.3s"
        position="relative"
        data-testid="big-switch-left"
      >
        {leftLabel}
      </Box>
      <Box
        flexGrow={1}
        textAlign="center"
        color={value ? 'stone' : 'onyx'}
        transition="color 0.3s"
        position="relative"
        data-testid="big-switch-right"
      >
        {rightLabel}
      </Box>
    </Flex>
  )
}

export default BigSwitch
